import React from "react";
import styled from "styled-components";
const Symbol = (props) => {
    return (React.createElement(TableRow, { onClick: () => props.callback(props.symbol) },
        React.createElement(TableDataCell, { align: "left", dangerouslySetInnerHTML: { __html: props.symbol.symbol } }),
        React.createElement(TableDataCell, { align: "left", switch: true, dangerouslySetInnerHTML: { __html: props.symbol.description } }),
        React.createElement(TableDataCell, { align: "right", webOnly: true },
            React.createElement(Type, null, props.symbol.type),
            React.createElement("span", null, props.symbol.exchange))));
};
const TableRow = styled.tr `
  cursor: pointer;
  width: 100%;
  border: none;
  transition: all 1s ease;

  &:hover {
    background: ${({ theme }) => theme.markets.background};
  }
`;
const TableDataCell = styled.td `
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  padding: 8px 5px 8px 5px;
  text-align: ${(props) => props.align};
  color: ${({ theme }) => theme.selector.color};
  font-weight: 300;

  & > em {
    font-style: normal;
    font-weight: 900;
  }

  ${(props) => props.webOnly &&
    `
      @media (max-width: 1000px) {
        display: none;
      };
  `}

  ${(props) => props.switch &&
    `
      padding-left: 20px;
      @media (max-width: 1000px) {
        text-align: right;
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      };
  `}
`;
const Type = styled.span `
  margin-right: 5px;
  color: rgba(255, 255, 255, 0.5);
`;
export default Symbol;
//# sourceMappingURL=Symbol.js.map